<template>
  <div class="home_main" style="text-align: center">
    <h1>Jasper的工具箱</h1>
    <p class="home_p">多功能工具箱，一站式解决日常所需快捷操作，欢迎提需求～</p>
    <img
      src="@/assets/images/tools_room.gif"
      alt="tool_room"
      class="main_image"
    />
    <!-- 图表和描述等内容区 -->
    <div class="row-wrapper">
      <el-row class="tools_card" :gutter="40">
        <el-col :xs="12" :lg="8">
          <router-link to="/ai_pet" class="router-link">
            <el-card>
              <div slot="header" class="header-with-background">
                <img src="@/assets/images/cat.png" alt="cat" class="card-image" />
                <img
                  src="@/assets/images/ai.png"
                  alt="ai"
                  class="card-tag-icon"
                />
              </div>
              <h3>宠物打卡自拍</h3>
              <p>人！喵到东方明珠了！</p>
            </el-card>
          </router-link>
        </el-col>
        <el-col :xs="12" :lg="8">
          <router-link to="/ai_toy" class="router-link">
            <el-card>
              <div slot="header" class="header-with-background">
                <img src="@/assets/images/ashin_toy.png" alt="ashin" class="card-image" />
                <img
                  src="@/assets/images/ai.png"
                  alt="ai"
                  class="card-tag-icon"
                />
              </div>
              <h3>人物手办化</h3>
              <p>将自拍变成手办风格</p>
            </el-card>
          </router-link>
        </el-col>
        <!-- <el-col :xs="12" :lg="8">
          <router-link to="/xuebi_travel" class="router-link">
            <el-card>
              <div slot="header" class="header-with-background">
                <img
                  src="@/assets/images/dog.png"
                  alt="dog"
                  class="card-image"
                />
                <img
                  src="@/assets/images/ai.png"
                  alt="ai"
                  class="card-tag-icon"
                />
              </div>
              <h3>雪碧旅行日记</h3>
              <p>再见了麻麻今晚我就要远航</p>
            </el-card>
          </router-link>
        </el-col> -->
        <el-col :xs="12" :lg="8">
          <router-link to="/salary" class="router-link">
            <el-card>
              <!-- Card内容 -->
              <div slot="header" class="header-with-background">
                <img
                  src="@/assets/images/money.png"
                  alt="webp"
                  class="card-image"
                />
              </div>
              <h3>工资实时计算器</h3>
              <p>上班摸鱼激励器</p>
            </el-card>
          </router-link>
        </el-col>
        <el-col :xs="12" :lg="8">
          <a
            href="http://hot.djp.org.cn"
            class="router-link"
          >
            <el-card>
              <!-- Card内容 -->
              <div slot="header" class="header-with-background">
                <img
                  src="@/assets/images/hot.png"
                  alt="facai"
                  class="card-image"
                />
              </div>
              <h3>今日热点资讯</h3>
              <p>汇聚全网热点，热门尽览无余</p>
            </el-card>
          </a>
        </el-col>
        <el-col :xs="12" :lg="8">
          <router-link to="/str_concat" class="router-link">
            <el-card>
              <!-- Card内容 -->
              <div slot="header" class="header-with-background">
                <img
                  src="@/assets/images/concat.png"
                  alt="concat"
                  class="card-image"
                />
              </div>
              <h3>字符串拼接</h3>
              <p>自定义连接符</p>
            </el-card>
          </router-link>
        </el-col>
        <el-col :xs="12" :lg="8">
          <router-link to="/pic_to_webp" class="router-link">
            <el-card>
              <!-- Card内容 -->
              <div slot="header" class="header-with-background">
                <img
                  src="@/assets/images/webpicon.png"
                  alt="webp"
                  class="card-image"
                />
              </div>
              <h3>图片转Webp</h3>
              <p>压缩图片，支持下载上传</p>
            </el-card>
          </router-link>
        </el-col>
        <el-col :xs="12" :lg="8">
          <router-link to="/sql_to_gostruct" class="router-link">
            <el-card>
              <!-- Card内容 -->
              <div slot="header" class="header-with-background">
                <img
                  src="@/assets/images/golang.png"
                  alt="webp"
                  class="card-image"
                />
              </div>
              <h3>SQL转Go Struct</h3>
              <p>一键生成Struct结构体</p>
            </el-card>
          </router-link>
        </el-col>
        <el-col :xs="12" :lg="8">
          <router-link to="/network_status" class="router-link">
            <el-card>
              <!-- Card内容 -->
              <div slot="header" class="header-with-background">
                <img
                  src="@/assets/images/network.png"
                  alt="network"
                  class="card-image"
                />
              </div>
              <h3>网络测速</h3>
              <p>查询网络状态和测速</p>
            </el-card>
          </router-link>
        </el-col>
        <el-col :xs="12" :lg="8">
          <a
            href="http://ashin.djp.org.cn/ashin/certificate_generator/index.html"
            class="router-link"
          >
            <el-card>
              <!-- Card内容 -->
              <div slot="header" class="header-with-background">
                <img
                  src="@/assets/images/kong.png"
                  alt="facai"
                  class="card-image"
                />
                <img
                  src="@/assets/images/dingzhi.png"
                  alt="dingzhi"
                  class="card-tag-icon card-dingzhi-icon"
                />
              </div>
              <h3>证书生成器</h3>
              <p>批量生成定制证书</p>
            </el-card>
          </a>
        </el-col>
        <el-col :xs="12" :lg="8">
          <el-card @click.native="showDialog = true">
            <!-- Card内容 -->
            <div slot="header" class="header-with-background">
              <img
                src="@/assets/images/coding.png"
                alt="coding"
                class="card-image"
              />
            </div>
            <h3>更多更新中...</h3>
            <p>欢迎提需求～</p>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      :visible.sync="showDialog"
      center
      @close="showDialog = false"
      class="contactmeDia"
    >
      <p>扫码加好友提需求～</p>
      <img
        src="@/assets/images/contact_me.webp"
        alt="联系我"
        class="contactmeImg"
      />
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Home",
  metaInfo: {
    title: "Jasper的工具箱", // 设置页面标题
    meta: [
      { name: "description", content: "大鸡排工作室出品！" }, // 设置页面描述
    ],
  },
  data() {
    return {
      showDialog: false,
    };
  },
};
</script>

<style>
.home_main {
  padding-top: 60px;
}

.main_image {
  width: 25%;
  height: auto;
}

.row-wrapper {
  margin: 0 auto;
  max-width: 50%;
  /* 确保这个容器是块级元素以支持自动外边距居中 */
  display: block;
}

.router-link {
  text-decoration: none; /* 移除默认下划线 */
}

/* 移除el-card组件的底部边框 */
.el-card__header {
  border-bottom: none !important;
  padding-bottom: 0;
}

.el-card__body {
  padding-top: 0;
}

.el-card__body {
  height: 100px; /* 设置为你希望的固定高度 */
  overflow: hidden; /* 隐藏超出部分的内容 */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 设置为你希望显示的行数 */
  white-space: normal; /* 允许换行 */
}

.header-with-background {
  position: relative;
  background-color: #f0f0f0; /* 浅灰色 */
  border-radius: 50%; /* 圆形 */
  width: 60px; /* 自定义宽度 */
  height: 60px; /* 自定义高度 */
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto; /* 可以根据需要调整位置 */
}

.card-image {
  width: 30px; /* 或者其他希望的宽度 */
}
.card-tag-icon {
  display: block;
  position: absolute;
  top: 0;
  right: -5px;
  width: 20px;
  height: auto;
}

.card-dingzhi-icon {
  width: 25px;
  height: auto;
}
.el-col {
  margin-bottom: 20px;
}

.el-dialog {
  width: 40%;
}

.contactmeDia .el-dialog__body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.contactmeImg {
  width: 180px;
  height: auto;
}

@media (max-width: 767px) {
  /* 这个宽度对应于Element UI中的xs断点 */
  .el-col {
    margin-bottom: 20px; /* 设置想要的上下间隔 */
  }

  .contactmeImg {
    width: 140px;
    height: auto;
  }
}

/* 如果你想让最后一个元素没有margin-bottom */
.el-col:last-child {
  margin-bottom: 0;
}

@media screen and (max-width: 540px) {
  .row-wrapper {
    max-width: 80%;
  }
  .el-col-xs-12 {
    padding: 0 8px !important;
  }
  .el-card__body p {
    display: block;
    font-size: 14px;
    margin: 0;
  }
  .main_image {
    margin-bottom: 20px;
    width: 140px;
    height: auto;
  }
  .home_p {
    padding: 0 20px;
  }
  .home_main {
    padding-top: 30px;
  }
  .home_main h1 {
    margin: 0;
  }
  .el-card__body {
    height: 85px;
  }
  .el-card__body h3 {
    margin: 20px 0 10px;
  }
  .contactmeImg {
    width: 120px;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue